import { Badge, Table } from '@radix-ui/themes'
import type { TRPCOutputs } from '~/utils/trpc'
import { installationRowClass, stageColor, stageLabel } from '~/features/installations/constants'
import { computeStage, isRetired } from '~/features/installations/service'
import { TicketCell } from '~/features/freshdesk/components/TicketBadge'
import { CompatibilityBadge } from '~/features/installations/components/CompatibilityBadge'
import { InstallationIdentityCells, InstallationIdentityHeaders } from './InstallationIdentityCells'

type Installation = TRPCOutputs['ops']['stationInstallations']['list'][number]

interface InstallationStatusTableProps {
  installations: Installation[]
  openTicketCounts: Record<string, number>
  onRowClick: (installationId: number) => void
}

export const InstallationStatusTable = ({
  installations,
  openTicketCounts,
  onRowClick
}: InstallationStatusTableProps) => (
  <Table.Root variant="surface">
    <Table.Header>
      <Table.Row>
        <InstallationIdentityHeaders />
        <Table.ColumnHeaderCell>Stage</Table.ColumnHeaderCell>
        <Table.ColumnHeaderCell>Compatibility</Table.ColumnHeaderCell>
        <Table.ColumnHeaderCell>Support</Table.ColumnHeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {installations.map((row) => {
        const stage = computeStage(row)
        return (
          <Table.Row
            key={row.installation_id}
            onClick={() => onRowClick(row.installation_id)}
            className={installationRowClass({ isStalled: row.current_stall !== null, isRetired: isRetired(row) })}
          >
            <InstallationIdentityCells installation={row} />
            <Table.Cell>
              <Badge color={stageColor[stage]} variant="soft" size="1">
                {stageLabel[stage]}
              </Badge>
            </Table.Cell>
            <Table.Cell>
              <CompatibilityBadge status={row.compatibility_status} />
            </Table.Cell>
            <Table.Cell onClick={(event) => event.stopPropagation()}>
              <TicketCell count={openTicketCounts[String(row.installation_id)] ?? 0} />
            </Table.Cell>
          </Table.Row>
        )
      })}
    </Table.Body>
  </Table.Root>
)
